import {
  ADD_NEW_USER,
  ADD_NEW_USER_FAILED,
  ADD_NEW_USER_SUCCESS,
  ASSIGN_CODE,
  ASSIGN_CODE_FAILED,
  ASSIGN_CODE_SUCCESS,
  GENERATE_CODE_FAILED,
  GENERATE_CODE_SUCCESS,
  GET_CODES_LIST,
  GET_CODES_LIST_FAILED,
  GET_CODES_LIST_SUCCESS,
  GET_CODE_BATCH,
  GET_CODE_BATCH_FAILED,
  GET_CODE_BATCH_SUCCESS,
  HIDE_ASSIGN_CODE_MODAL,
  HIDE_CREATE_USER_MODAL,
  HIDE_REASSIGN_CODE_MODAL,
  HIDE_REINSTATE_CODE_MODAL,
  OPEN_ASSIGN_CODE_MODAL,
  OPEN_CREATE_USER_MODAL,
  OPEN_REASSIGN_CODE_MODAL,
  OPEN_REINSTATE_CODE_MODAL,
  REASSIGN_CODE,
  REASSIGN_CODE_FAILED,
  REASSIGN_CODE_SUCCESS,
  REINSTATE_CODE,
  REINSTATE_CODE_FAILED,
  REINSTATE_CODE_SUCCESS,
  RESET_CREATED_USER,
  RETRY_BATCH,
  RETRY_BATCH_FAILED,
  RETRY_BATCH_SUCCESS,
  GENERATE_CODE,
  DELETE_BATCH,
  DELETE_BATCH_SUCCESS,
  DELETE_BATCH_FAILED,
} from "./actionTypes"

export const getCodesList = params => ({
  type: GET_CODES_LIST,
  payload: params,
})

export const getCodesListSuccess = response => ({
  type: GET_CODES_LIST_SUCCESS,
  payload: response,
})

export const getCodesListFailed = error => ({
  type: GET_CODES_LIST_FAILED,
  payload: error,
})

export const getCodeBatch = params => ({
  type: GET_CODE_BATCH,
  payload: params,
})

export const getCodeBatchSuccess = response => ({
  type: GET_CODE_BATCH_SUCCESS,
  payload: response,
})

export const getCodeBatchFailed = error => ({
  type: GET_CODE_BATCH_FAILED,
  payload: error,
})

export const retryBatch = params => ({
  type: RETRY_BATCH,
  payload: params,
})

export const retryBatchSuccess = response => ({
  type: RETRY_BATCH_SUCCESS,
  payload: response,
})

export const retryBatchFailed = error => ({
  type: RETRY_BATCH_FAILED,
  payload: error,
})

export const openAssignCodeModal = () => ({
  type: OPEN_ASSIGN_CODE_MODAL,
  payload: {},
})

export const hideAssignCodeModal = () => ({
  type: HIDE_ASSIGN_CODE_MODAL,
  payload: {},
})

export const openCreateUserModal = () => ({
  type: OPEN_CREATE_USER_MODAL,
  payload: {},
})

export const hideCreateUserModal = () => ({
  type: HIDE_CREATE_USER_MODAL,
  payload: {},
})

export const addNewUser = params => ({
  type: ADD_NEW_USER,
  payload: params,
})

export const addNewUserSuccess = response => ({
  type: ADD_NEW_USER_SUCCESS,
  payload: response,
})

export const addNewUserFailed = error => ({
  type: ADD_NEW_USER_FAILED,
  payload: error,
})

export const resetCreatedUser = () => ({
  type: RESET_CREATED_USER,
  payload: {},
})

export const openReassignCodeModal = () => ({
  type: OPEN_REASSIGN_CODE_MODAL,
  payload: {},
})

export const hideReassignCodeModal = () => ({
  type: HIDE_REASSIGN_CODE_MODAL,
  payload: {},
})

export const openReinstateCodeModal = () => ({
  type: OPEN_REINSTATE_CODE_MODAL,
  payload: {},
})

export const hideReinstateCodeModal = () => ({
  type: HIDE_REINSTATE_CODE_MODAL,
  payload: {},
})

export const assignCode = params => ({
  type: ASSIGN_CODE,
  payload: params,
})

export const assignCodeSuccess = response => ({
  type: ASSIGN_CODE_SUCCESS,
  payload: response,
})

export const assignCodeFailed = error => ({
  type: ASSIGN_CODE_FAILED,
  payload: error,
})

export const reinstateCode = params => ({
  type: REINSTATE_CODE,
  payload: params,
})

export const reinstateCodeSuccess = response => ({
  type: REINSTATE_CODE_SUCCESS,
  payload: response,
})

export const reinstateCodeFailed = error => ({
  type: REINSTATE_CODE_FAILED,
  payload: error,
})

export const reassignCode = params => ({
  type: REASSIGN_CODE,
  payload: params,
})

export const reassignCodeSuccess = response => ({
  type: REASSIGN_CODE_SUCCESS,
  payload: response,
})

export const reassignCodeFailed = error => ({
  type: REASSIGN_CODE_FAILED,
  payload: error,
})

export const generateCode = params => ({
  type: GENERATE_CODE,
  payload: params,
})

export const generateCodeSuccess = response => ({
  type: GENERATE_CODE_SUCCESS,
  payload: response,
})

export const generateCodeFailed = error => ({
  type: GENERATE_CODE_FAILED,
  payload: error,
})

export const deleteBatch = params => ({
  type: DELETE_BATCH,
  payload: params,
})

export const deleteBatchSuccess = response => ({
  type: DELETE_BATCH_SUCCESS,
  payload: response,
})

export const deleteBatchFailed = error => ({
  type: DELETE_BATCH_FAILED,
  payload: error,
})
